import React from "react";
import "./Filter.css";

const Filter = ({ children, backgroundcolor }) => {
  return (
    <div className="filter-component">
      <div className="filter-overlay" style={{ backgroundColor: backgroundcolor }}></div>
      {children}
    </div>
  );
};

export default Filter;
